<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
    <div class="row">
        <div class="col">
            <div class="d-flex justify-content-between">
                <div>
                    <label for="information" class="labelInformation">List Of Devices</label>
                </div>
                <div class="col btn-back text-end">
                    <button class="btn btn-secondary" (click)="goBack()">Back</button>
                </div>
            </div>
        </div>

    </div>
    <div class="row">
        
    </div>


    <div class="row">
        <div class="col">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="pills-devices-tab" data-bs-toggle="pill"
                        data-bs-target="#pills-devices" type="button" role="tab" aria-controls="pills-home"
                        aria-selected="true">Devices</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="pills-consumption-tab" data-bs-toggle="pill"
                        data-bs-target="#pills-consumption" type="button" role="tab" aria-controls="pills-profile"
                        aria-selected="false">Usage MB</button>
                </li>

            </ul>
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-devices" role="tabpanel"
                    aria-labelledby="pills-home-tab">
                    <div class="row">
                        <div class="mb-3">
                            <div class="dropdown float-end" style="width: 140px;">
                                <button class="btn btn-secondary dropdown-toggle custom-hover custom-active"
                                    type="button" id="dropdownReportButton" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-file-earmark-spreadsheet"></i>
                                    Export data
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownReportButton">
                                    <li>
                                        <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevicesConsolidated()">
                                            <i class="bi bi-file-earmark-text"></i>
                                            Consolidated
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevices()">
                                            <i class="bi bi-file-earmark-text"></i>
                                            Detailed
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item custom-hover" (click)="openConfirmationData()">
                                            <i class="bi bi-file-earmark-text"></i> Detailed Annual
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <app-table-control [columns]="devicesColumns" [data]="devices" [pageSize]="5" [actionButtons]="actionButtons" (actionClick)="onAction($event)" [showActions]="true"></app-table-control>
                    </div>

                </div>
                <div class="tab-pane fade" id="pills-consumption" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <app-consumption-view style="height: 600px" [data]="usageData"></app-consumption-view>
                </div>

            </div>
        </div>

    </div>
</div>


<div class="modal fade" id="confirmationData" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
          Report Filters
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="exportToExcelListPlanDevicesAnnual(false)"></button>
      </div>
      <div class="modal-body">
        <div class="fw-bold bg-white p-3 rounded-5 mb-5">
          <!-- Primera fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="information">Please select the start and end dates for the report query.</label>
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="fromDate">From Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="fromDate"
                id="fromDate" name="fromDate" />
            </div>

            <div class="col">
              <label for="toDate">To Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="toDate"
                [min]="minDate()" id="toDate" name="toDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="exportToExcelListPlanDevicesAnnual(false)">
          Close
        </button>
        <!-- <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlan(true)"
            [disabled]="!fieldsCompleted">
            Yes, Update
          </button> -->
        <button type="button" class="btn btn-primary" (click)="exportToExcelListPlanDevicesAnnual(true)"
          [disabled]="!fieldsCompletedFilter">
          Generate Report
        </button>
      </div>
    </div>
  </div>
</div>
